import React, { useEffect, useState } from 'react';

const RetailerFitGuide_ImageGrid = ({ images }) => {
    if (!images?.length > 0)
        return;
    const [showAll, setShowAll] = useState(false);
    const [zoom, setZoom] = useState(false);
    useEffect(() => {
        if (zoom) {
            document.body.classList.add("overflow-hidden");
            document.getElementById(zoom).scrollIntoView();
        }
        else
            document.body.classList.remove("overflow-hidden");

        return () => {
            document.body.classList.remove("overflow-hidden");
        };
    }, [zoom]);

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setZoom(null);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <div className="retailerFitGuide_ImageGrid d-none d-lg-block">
            <div className={`pdp__mainImages ${zoom && "imageGrid__zoom"}`}>
                <div className="mainImages__container d-flex flex-wrap">
                    {images.map((image, index) => {
                        return <div key={index} className={`pdp__mainImageWrapper ${index < 4 || showAll || zoom ? "" : "d-none"}`}>
                            <img onClick={() => setZoom(`pdp_mainImage_${index}`)} id={`pdp_mainImage_${index}`} className="pdp__mainImage" alt={image.alt} src={image.src} loading="lazy" />
                        </div>
                    })}
                </div>
                {!zoom && images?.length > 4 && <div className='d-flex justify-content-center'><button onClick={() => setShowAll(!showAll)} className="mx-auto mt-7 btn thule-btn-secondary">
                    <span>{showAll ? "Show less" : "Show all"}</span>
                </button></div>}

                {zoom && <button onClick={() => setZoom(null)} className="btn p-0 zoomClose"><span className="sr-only">Close image</span><i className="le-icon-x"></i></button>}
            </div>
        </div >
    );
};

export default RetailerFitGuide_ImageGrid;